
import React from 'react';

const TemplateHero1 = ({ branding }) => {
  const styles = {
    heroContainer: {
      position: 'relative',
      height: '80vh',
      width: '100%',
      backgroundImage: `url('https://images.pexels.com/photos/2325446/pexels-photo-2325446.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      textAlign: 'center',
      fontFamily: branding?.heroTitleFontFamily || 'Arial, sans-serif'
    },
   overlay: {
      position: 'absolute',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'var(--hero-overlay-color, rgba(0,0,0,0.4))', // Use variable
    },
    content: {
      position: 'relative',
      zIndex: 1,
    },
    title: {
      fontFamily: 'var(--hero-title-font-family, "Arial, sans-serif")', // Use variable
      fontSize: '4rem',
      fontWeight: 'bold',
      margin: '0 0 1rem 0',
      textShadow: '2px 2px 8px rgba(0,0,0,0.6)'
    },
   subtitle: {
      fontSize: '1.25rem',
      marginBottom: '2rem',
      color: 'var(--secondary-text-color, #e9ecef)', // Let's use a specific variable name for clarity
    },
    buttonGroup: {
      display: 'flex',
      gap: '1rem',
      justifyContent: 'center',
    },
  };

  return (
    <div style={styles.heroContainer}>
  <div style={styles.overlay}></div>
  <div style={styles.content}>
    {/* --- Start of replaceable section --- */}
   
    <h1 style={{ ...styles.title, color: 'white' }}>Your Next Adventure Awaits</h1>

    <p style={styles.subtitle}>Explore our curated packages to the world's most breathtaking destinations.</p>
    {/* --- End of replaceable section --- */}
    <div style={styles.buttonGroup}>
      <button className="btn btn-primary btn-lg rounded-pill px-4">Explore Now</button>
      <button className="btn btn-outline-light btn-lg rounded-pill px-4">Learn More</button>
    </div>
  </div>
</div>
  );
};

export default TemplateHero1;
